import Router, { RouteConfig } from 'vue-router';
import dataRouter, { iesDataRouter } from './data-management';

import DataView from '@/layout/data-manage/data-view.vue';
import Diagram from '@/views/Diagram';
import Layout from '@/layout/layout.vue';
import PrioritizationScheme from '@/prioritization/prioritization-scheme/prioritization-scheme.vue';
import Vue, { VueConstructor } from 'vue';
import digitalTwins from '@/component/DigitalTwins/index.vue';
import evaluateRouter from '@/component/evaluate/router';
import { message } from 'ant-design-vue';
import store from '../store/store';
const ProjectOverView = (): unknown => import('@/component/project/project-overview.vue');
Vue.use(Router);
const routes: RouteConfig[] = [
    {
        path: '/',
        name: 'indexpage',
        component: Layout,
        meta: { requireAuth: true },
        children: [
            {
                path: 'diagram',
                name: 'diagram',
                component: Diagram,
                meta: { requireAuth: true },
            },
            {
                path: 'gmm',
                name: 'gmm',
                component: Diagram,
                meta: { requireAuth: true },
            },
            {
                path: 'scenario-generate',
                name: 'scenario-generate',
                component: Diagram,
                meta: { requireAuth: true },
            },
            {
                path: 'resilience-eval',
                name: 'resilience-eval',
                component: Diagram,
                meta: { requireAuth: true },
            },
            {
                path: 'resilience-plan',
                name: 'resilience-plan',
                component: Diagram,
                meta: { requireAuth: true },
            },
            {
                path: 'resilience-recovery',
                name: 'resilience-recovery',
                component: Diagram,
                meta: { requireAuth: true },
            },
        ],
    },
    {
        path: '/request_auth',
        name: 'request_auth',
        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
        component: () => import('@/component/request/request-auth.vue'),
        meta: { title: 'request', permission: ['admin', 'user'] },
    },
    {
        path: '/header',
        name: '/header',
        redirect: '/header/data/weather',
        component: Layout,
        children: [
            dataRouter,
            {
                path: 'scheme',
                name: 'scheme',
                component: DataView,
                meta: { requireAuth: true },
                redirect: 'scheme/prioritization',
                children: [
                    {
                        path: 'prioritization',
                        component: PrioritizationScheme,
                        name: 'prioritization',
                        meta: {
                            title: '优化方案',
                            role: ['admin', 'editor'],
                            icon: 'weather',
                        },
                    },
                ],
            },
            evaluateRouter,
            {
                path: 'digitalTwins',
                name: 'digitalTwins',
                component: DataView,
                meta: { requireAuth: true },
                redirect: 'digitalTwins/index',
                children: [
                    {
                        path: 'index',
                        component: digitalTwins,
                        name: 'digitalTwins-index',
                        meta: {
                            title: '数字孪生体交付',
                            role: ['admin', 'editor'],
                            // icon: 'weather',
                        },
                    },
                ],
            },
        ],
    },
    {
        path: '/ies',
        name: '/ies',
        component: Layout,
        meta: { requireAuth: true },
        redirect: '/ies/simu/open/',
        children: [
            {
                path: 'diagram',
                name: 'ies/diagram',
                component: Diagram,
                meta: { title: '综合能源建模仿真平台', requireAuth: true },
            },
            {
                path: 'run-simulation',
                name: 'ies/run-simulation',
                component: Diagram,
                meta: { title: '综合能源建模仿真平台', requireAuth: true },
            },
            {
                path: 'run-optimization',
                name: 'ies/run-optimization',
                component: Diagram,
                meta: { title: '综合能源建模仿真平台', requireAuth: true },
            },
        ],
    },
    {
        path: '/ies/header',
        name: '/ies/header',
        component: Layout,
        meta: { requireAuth: true },
        redirect: '/ies/header/data/weather',
        children: [iesDataRouter],
    },
    {
        path: '/project',
        name: '/project',
        component: Layout,
        redirect: '/project/overview',
        meta: { requireAuth: true },
        children: [
            {
                path: 'overview',
                name: 'overview',
                component: ProjectOverView as unknown as VueConstructor<Vue>,
                meta: { requireAuth: true, title: '项目概览', role: ['admin', 'editor'] },
            },
        ],
    },
];

export const newrouter = new Router({
    mode: 'history',
    base: 'ieslab',
    routes: routes,
});

//路由免疫名单

const whiteList = ['/request_auth'];

newrouter.beforeEach((to, from, next) => {
    if ((to.meta as Record<string, unknown>).title) {
        document.title = (to.meta as Record<string, unknown>).title as string;
    } else {
        document.title = '综合能源规划设计平台';
    }

    const redirect = decodeURIComponent((from.query.redirect as string) || to.path);
    //白名单判断
    if (whiteList.indexOf(to.path) >= 0) {
        next();
    } else {
        const token = (JSON.parse(localStorage.getItem('ACCESS-TOKEN') as string) as { value: string })?.value;
        if (store.getters.getToken.length === 0) {
            store.commit('setToken', token);
        }
        /** 在每次跳转后都进行用户验证 */
        store
            .dispatch('putUserInfo')
            .then(() => {
                if (to.path === redirect) {
                    next();
                } else next(redirect);
            })
            .catch((e) => {
                console.log(e);
                void message.warn('权限验证不通过,已返回登陆页!');
                /** 发生错误时无脑跳到登录页 */
                const url = new URL(`${location.origin}/account`);
                window.open(url.href, '_self');
            });
    }
});
export default newrouter;
export { routes };
